import API from "@/API";
import dataTableCreator from "@/store/creators/dataTable";

const SET_SELECTED_NOTIFICATION = "SET_SELECTED_NOTIFICATION";
const SET_NOTIFICATION_TYPE = "SET_NOTIFICATION_TYPE";

const state = {
  notificationType: ""
};

const actions = {
  async getItems({ state, dispatch }) {
    dispatch("stopLoader");

    try {
      let results = await API.Notifications.listAll();

      dispatch("setTotalItems", results.totalItems);
      dispatch("setItems", results.data);
    } catch (e) {
      dispatch("stopLoader");
      throw "Não foi possivel filtrar as notificações!";
    }

    dispatch("stopLoader");
  },

  async listAll({ dispatch }) {
    dispatch("startLoader");
    try {
      let results = await API.Notifications.listAll();

      dispatch("setTotalItems", results.totalItems);
      dispatch("setItems", results.data);
    } catch (e) {
      dispatch("stopLoader");
      throw "Não foi possivel filtrar as notificações!";
    }
    dispatch("stopLoader");
  },

  setNotificationType({ commit, dispatch }, notificationType) {
    commit("SET_NOTIFICATION_TYPE", notificationType);
    dispatch("listAll");
  }
};

const mutations = {
  [SET_SELECTED_NOTIFICATION](state, payload) {
    state.selected.id = payload;
  },

  [SET_NOTIFICATION_TYPE](state, payload) {
    state.notificationType = payload;
  }
};
export default {
  namespaced: true,
  state: { ...dataTableCreator.state, ...state },
  actions: { ...dataTableCreator.actions, ...actions },
  mutations: { ...dataTableCreator.mutations, ...mutations },
  getters: dataTableCreator.getters
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js